import { BannerProvider } from "./../../../../node_modules/@playcharge/common/models/backend/banners/banner-provider";
import { ChangeDetectionStrategy, Component, effect, inject, signal } from "@angular/core";
import { BannersStore } from "../../stores/banners/banners.store";
import { CommonModule } from "@angular/common";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { BannerBackOfficeViewModel } from "@playcharge/common/models/backend/banners/backoffice/banner-backoffice-view-model";
import { MatDialog } from "@angular/material/dialog";
import { EditBannerDialogComponent } from "../dialogs/edit-banner-dialog/edit-banner-dialog.component";
import { BannerEditModel } from "@playcharge/common/models/backend/banners/backoffice/banner-edit-model";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { EMPTY, mergeMap } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: "app-banners",
    standalone: true,
    imports: [CommonModule, MatTableModule, MatIcon, MatButton, MatCheckbox],
    templateUrl: "./banners.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannersComponent {
    private _matDialog = inject(MatDialog);
    private _toastrService: ToastrService = inject(ToastrService);

    public bannersStore = inject(BannersStore);

    public displayedColumns = signal(["provider", "countries", "active", "actions"]);

    public dataSource: MatTableDataSource<BannerBackOfficeViewModel> =
        new MatTableDataSource<BannerBackOfficeViewModel>();

    public BannerProvider = BannerProvider;

    constructor() {
        effect(() => {
            this.dataSource.data = this.bannersStore.entities();
        });
    }

    public openEditBanner(banner?: BannerBackOfficeViewModel) {
        const isEditMode = !!banner;

        this._matDialog
            .open<EditBannerDialogComponent, Nullable<BannerBackOfficeViewModel>, BannerEditModel>(
                EditBannerDialogComponent,
                {
                    data: banner,
                },
            )
            .afterClosed()
            .pipe(
                mergeMap((value) => {
                    if (value) {
                        if (isEditMode) {
                            return this.bannersStore.updateBanner(value);
                        }

                        return this.bannersStore.createBanner(value);
                    }

                    return EMPTY;
                }),
            )
            .subscribe({
                next: () => this._toastrService.success("Done"),
                error: (error: HttpErrorResponse) =>
                    this._toastrService.error(error?.error?.description ?? "Internal Error"),
            });
    }
}
